/*
 * @Description:
 * @Date: 2022-12-01 17:16:34
 * @LastEditTime: 2025-06-04 17:39:27
 */
import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'
const service = axios.create({
  // baseURL:'http://192.168.2.246:9011',
  baseURL: 'http://www.piichw.com/api', // 保际
  timeout: 60000,
})

service.interceptors.request.use(
  (config) => {
    config.headers.Authorization = 'Bearer ' + getToken()
    if (config.headers.loding === 1) {
      // 全局
      store.commit('user/SET_LOADING', true)
    } else if (config.headers.loding === 2) {
      // user
      store.commit('user/SET_MAIN_LOADING', true)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    store.commit('user/SET_LOADING', false)
    store.commit('user/SET_MAIN_LOADING', false)
    const res = response.data
    if (res.status !== 200) {
      if (res.status == 440) {
        // Message({
        //   message: '身份过期，请重新登录',
        //   type: 'error',
        //   duration: 2 * 1000
        // })
        removeToken()
        store.commit('user/SET_MODULE_FLAG', true)
        store.commit('user/LOGIN_OUT')
        return
      } else {
        Message({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000,
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    store.commit('user/SET_LOADING', false)
    store.commit('user/SET_MAIN_LOADING', false)
    Message({
      // message: error.message,
      message: '系统升级中，请耐心等待～',
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)

export default service
